/**
 * ROG Price Animation System
 * Mini animations discrètes lors du changement de variante
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    priceSelector: '.price--large',
    variantSelector: 'input[name="id"], select[name="id"]',
    animationClass: 'price--updating',
    highlightClass: 'price--highlight',
    colorTransitionClass: 'price--color-transition',
    animationDuration: 400,
    debounceDelay: 100
  };

  // État de l'animation
  let isAnimating = false;
  let animationTimeout = null;

  /**
   * Déclenche une animation discrète sur le prix
   */
  function animatePrice(priceElement, animationType = 'update') {
    if (!priceElement || isAnimating) return;

    isAnimating = true;

    // Nettoyer les classes précédentes
    priceElement.classList.remove(
      CONFIG.animationClass,
      CONFIG.highlightClass,
      CONFIG.colorTransitionClass
    );

    // Forcer un reflow pour s'assurer que les classes sont supprimées
    priceElement.offsetHeight;

    // Ajouter la classe d'animation appropriée
    switch (animationType) {
      case 'update':
        priceElement.classList.add(CONFIG.animationClass);
        break;
      case 'highlight':
        priceElement.classList.add(CONFIG.highlightClass);
        break;
      case 'color':
        priceElement.classList.add(CONFIG.colorTransitionClass);
        break;
    }

    // Nettoyer après l'animation
    clearTimeout(animationTimeout);
    animationTimeout = setTimeout(() => {
      priceElement.classList.remove(
        CONFIG.animationClass,
        CONFIG.highlightClass,
        CONFIG.colorTransitionClass
      );
      isAnimating = false;
    }, CONFIG.animationDuration + 50);
  }

  /**
   * Observe les changements de prix dans le DOM
   */
  function observePriceChanges() {
    const priceElements = document.querySelectorAll(CONFIG.priceSelector);
    
    priceElements.forEach(priceElement => {
      // Observer les changements de contenu
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || 
              (mutation.type === 'characterData' && mutation.target.textContent)) {
            // Débounce pour éviter les animations multiples
            clearTimeout(animationTimeout);
            animationTimeout = setTimeout(() => {
              animatePrice(priceElement, 'update');
            }, CONFIG.debounceDelay);
          }
        });
      });

      // Observer les changements dans l'élément prix et ses enfants
      observer.observe(priceElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  /**
   * Écoute les changements de variante
   */
  function listenToVariantChanges() {
    const variantInputs = document.querySelectorAll(CONFIG.variantSelector);
    
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        const priceElements = document.querySelectorAll(CONFIG.priceSelector);
        priceElements.forEach(priceElement => {
          // Animation légèrement retardée pour synchroniser avec le changement de prix
          setTimeout(() => {
            animatePrice(priceElement, 'color');
          }, 50);
        });
      });
    });
  }

  /**
   * Écoute les événements Shopify de changement de variante
   */
  function listenToShopifyEvents() {
    // Événement Shopify standard
    document.addEventListener('variant:change', (event) => {
      const priceElements = document.querySelectorAll(CONFIG.priceSelector);
      priceElements.forEach(priceElement => {
        setTimeout(() => {
          animatePrice(priceElement, 'update');
        }, 100);
      });
    });

    // Événement personnalisé pour les thèmes avancés
    document.addEventListener('product:variant-change', (event) => {
      const priceElements = document.querySelectorAll(CONFIG.priceSelector);
      priceElements.forEach(priceElement => {
        setTimeout(() => {
          animatePrice(priceElement, 'highlight');
        }, 150);
      });
    });
  }

  /**
   * Animation au survol pour feedback utilisateur
   */
  function addHoverEffects() {
    const priceElements = document.querySelectorAll(CONFIG.priceSelector);
    
    priceElements.forEach(priceElement => {
      priceElement.addEventListener('mouseenter', () => {
        if (!isAnimating) {
          priceElement.style.transform = 'translateY(-1px)';
        }
      });

      priceElement.addEventListener('mouseleave', () => {
        if (!isAnimating) {
          priceElement.style.transform = '';
        }
      });
    });
  }

  /**
   * Initialisation du système d'animation
   */
  function init() {
    // Attendre que le DOM soit prêt
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Petite pause pour s'assurer que tous les éléments sont chargés
    setTimeout(() => {
      observePriceChanges();
      listenToVariantChanges();
      listenToShopifyEvents();
      addHoverEffects();

      // Animation d'apparition initiale
      const priceElements = document.querySelectorAll(CONFIG.priceSelector);
      priceElements.forEach((priceElement, index) => {
        setTimeout(() => {
          priceElement.style.opacity = '0';
          priceElement.style.transform = 'translateY(5px)';
          
          setTimeout(() => {
            priceElement.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            priceElement.style.opacity = '1';
            priceElement.style.transform = 'translateY(0)';
          }, 50);
        }, index * 100);
      });

      console.log('ROG Price Animation System initialized');
    }, 500);
  }

  /**
   * API publique pour déclencher des animations manuellement
   */
  window.ROGPriceAnimation = {
    animate: animatePrice,
    highlight: (selector) => {
      const element = document.querySelector(selector || CONFIG.priceSelector);
      if (element) animatePrice(element, 'highlight');
    },
    colorTransition: (selector) => {
      const element = document.querySelector(selector || CONFIG.priceSelector);
      if (element) animatePrice(element, 'color');
    }
  };

  // Initialiser le système
  init();

})();

